import { createElement } from 'react';
import { useDesignTokens, DesignTokens, renderDesignTokens } from '../../theme';
import type { DividerProps } from './types';
import cx from 'classnames';
import './Divider.css';
import cn from './Divider.css.json';

export const Divider = (props: DividerProps) => {
  const dt = useDesignTokens();
  const tokens = {
    ...getDividerDesignTokens(dt, { disabled: props.disabled }),
    ...props.theme?.(dt),
  };

  return <hr className={cx(cn.divider, props.className)} style={{ ...tokens, ...props.style }} />;
};

export const getDividerDesignTokens = (dt: DesignTokens, opts: { disabled?: boolean }) => {
  return renderDesignTokens(
    {
      bd: opts.disabled ? dt.stateStandardNova.disabled.bd : dt.c.colorUiBorder,
    },
    'divider'
  );
};
